<!-- 扫码添加设备 -->
<template>
  <el-dialog :model-value="modelValue" width="60%" @close="handleClosed">
    <template #header>
      添加<span style="color: red">{{ titleName }}</span
      >设备
    </template>
    <el-row>
      <el-col :span="24">
        <el-input
          ref="inputRef"
          autofocus
          placeholder="请输入设备编号或使用扫码枪进行扫描"
          type="textarea"
          :rows="6"
          v-model="inputData"
          clearable
        ></el-input>
      </el-col>
      <!-- <el-col :span="3" style="padding-left: 5px">
        <el-button type="primary" @click="handleAdd">添加</el-button>
      </el-col> -->
    </el-row>
    <template v-if="showTable">
      <Table
        ref="tableRef"
        class="mr20 mt5"
        :showSearchIcon="false"
        :showFun="false"
        :data="tableData"
        :columns="columns"
        rowKey="eqptCode"
      >
      </Table>
    </template>
    <template v-if="tableDataErr.length > 0">
      <div class="errDate">
        以下设备号未在应盘点范围内
        <el-scrollbar height="200px" class="mt10">
          <div>
            <template v-for="(item, index) in tableDataErr">
              <el-tag class="mr20 mt5" style="width: 150px" type="danger"
                >{{ item }}
              </el-tag>
            </template>
          </div>
        </el-scrollbar>
      </div>
    </template>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClosed">关闭</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
// import Dialog from "@/components/Element/Dialog";
import { ref, onMounted, watch, nextTick } from "vue";
import Table from "@/components/Element/Table";
import { isNull } from "@/utils/fangerUtils";
const props = defineProps({
  titleName: {
    type: String,
    default: "",
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  showTable: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Array,
    default: () => [],
  },
  tableData: {
    type: Array,
    default: () => [],
  },
  tableDataErr: {
    type: Array,
    default: () => [],
  },
  columns: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(["update:modelValue", "success", "closeDialog"]);

const inputRef = ref(null);
const inputData = ref("");
const eqptList = ref([]);

const handleClosed = () => {
  emits("update:modelValue", false);
  emits("closeDialog");
};

const handleAdd = () => {
  inputRef.value.focus();
  if (isNull(inputData.value)) return;
  const eqptCodeStrList = inputData.value.split(/[,，\s\r\n]+/);
  eqptCodeStrList.forEach((item) => {
    if (!isNull(item)) {
      eqptList.value.push({ eqptCode: item });
    }
  });
  inputData.value = "";
};

const handleConfirm = () => {
  handleAdd();
  emits("success", eqptList.value);
  // handleClosed();
};
const eqptErrCode = ref();
onMounted(() => {
  watch(
    () => props.data,
    (newVal) => {
      eqptList.value = newVal;
    }
  );
  watch(
    () => props.tableDataErr,
    (newVal) => {
      eqptErrCode.value = newVal.join(",");
    }
  );
  watch(
    () => props.modelValue,
    (newVal) => {
      if (newVal) {
        setTimeout(() => {
          inputRef.value.focus();
        }, 100);
      }
    }
  );
});
</script>

<style lang="scss" scoped>
.errDate {
  font-size: 25px;
  color: red;
  margin-top: 25px;
  width: 100%;
  .eqptCode {
    width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
